import { createAdminExchangeRateFormValues } from "@/schemas/exchange-rate";
import {
  createData,
  deleteData,
  fetchData,
  updateData,
} from "@/services/api-service";

export type AdminExchangeRate = {
  id: string;
  currencyCode: string;
  amount: string;
  version: number;
  updatedAt: string;
  owner: boolean;
  basedCurrencyCode: string;
};

export const ADMIN_EXCHANGE_RATE_ENDPOINT = "/admin/exchange-rate";

export type CreateAdminExchangeRateDto = {
  nonce: string;
  payload: createAdminExchangeRateFormValues;
};

export type UpdateAdminExchangeRateDto = {
  nonce: string;
  payload: {
    amount: number;
  };
};

export const adminExchangeRateApi = {
  // Get a single exchange rate by ID
  getById: (id: number) =>
    fetchData<AdminExchangeRate>(`${ADMIN_EXCHANGE_RATE_ENDPOINT}/${id}`),

  // Create a new exchange rate
  create: (data: CreateAdminExchangeRateDto) =>
    createData<AdminExchangeRate>(ADMIN_EXCHANGE_RATE_ENDPOINT, data),

  // Update an existing exchange rate
  update: (id: string, data: UpdateAdminExchangeRateDto) =>
    updateData<AdminExchangeRate>(`${ADMIN_EXCHANGE_RATE_ENDPOINT}`, id, data),

  // Delete a exchange rate
  delete: (id: number) => deleteData(ADMIN_EXCHANGE_RATE_ENDPOINT, id),
};
